import { FmCommunicationSettings } from 'src/app/types/models/user/notification-preferences/notification-settings';
import { Address } from '../../types/models/address';
import { Gender, Name, Position } from '../../types/models/user';
import { AdminRolesModel } from './admin-roles.model';
export interface UserModel {
  address?: Address;
  avatar: string;
  email: string;
  firstLogin: string;
  fullName: string;
  gender: Gender;
  isDisabled: boolean;
  isSuperAdmin?: boolean;
  name: Name;
  phone: string;
  position: Position;
  _id: string;
  permissions?: AdminRolesModel;
  doNotShowInstaShyftMessage: boolean;
  hmacs: any;
  fmCommunicationSettings?: FmCommunicationSettings
}

export function isAutomatedUser(user: UserModel): boolean {
  const regex = /^auto\d*\+.*@eshyft\.com$/;
  return regex.test(user?.email || '');
}
